import "./component-library97.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "PlayButton",
  props: {
    colorIcon: { type: String, default: "#fff" },
    background: { type: String, default: "#e20074" }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "play-button" }, [_c("svg", { staticClass: "play-button__svg", attrs: { "xmlns": "http://www.w3.org/2000/svg", "viewBox": "0 0 120 120" } }, [_c("circle", { attrs: { "cx": "60", "cy": "60", "r": "36", "fill": _vm.background } }), _c("polygon", { attrs: { "points": "51 46.3 51 73.7 74 60 51 46.3", "fill": _vm.colorIcon } })])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "9b799bb4",
  null,
  null
);
const PlayButton = __component__.exports;
export {
  PlayButton as default
};
